// @flow
import $ from 'jquery';
import JQueryView, { on } from './JQueryView';

export default class ApproveWarningDialog extends JQueryView {
  form: string;

  constructor(form: string = '') {
    super('.approve-warning');
    this.form = form;
  }

  submitApprovedRequireForm = () => {
    const $form = $(this.form);
    const input = $('<input>')
      .attr({ type: 'hidden', name: 'require_approve' })
      .val(true);
    $form.append(input);
    $form.submit();
  };

  @on({ event: 'click', selector: '.approve-warning__action.submit' })
  submit(e: any) {
    e.preventDefault();
    e.stopPropagation();
    this.submitApprovedRequireForm();
  }

  render(element: any, action: string = 'submit') {
    const message = $(element).data('message');
    $('.approve-warning__action').addClass(action);
    const { href } = element;
    if (href) {
      $('.approve-warning__action').attr('href', href);
    }
    $('.approve-warning__message').html(message);
    $('#approve-warning-modal').modal('show');
  }
}
